import React, { useContext } from 'react';
import { CentralProviderContext, CentralProviderHeader, CurrentLocationAvatar } from '@michelin/central-provider';
import { ProfileMenuItemProps } from '@michelin/central-provider/dist/components/ProfileBox/ProfileMenuItem';
import clsx from 'clsx';
import { useStyles } from './headerStyles';

function Header() {
  const centralProviderContext = useContext(CentralProviderContext);
  const classes = useStyles();
  const menuItems: ProfileMenuItemProps[] = [];

  return (
    <div className={clsx(classes.appBar)}>
      <CentralProviderHeader
        profileMenuItems={menuItems}
        appTitle="Urban"
        logoType="michelin"
        customLink={
          <CurrentLocationAvatar
            allowMstMode={false}
            allowedAccountTypes="both"
            accountSelectorLevels={['HO', 'BT', 'ST']}
            allowedCountryCodes={['US']}
            enableStateFiltering={centralProviderContext.hasFullAccountAccess('any')}
          />
        }
      />
    </div>
  );
}

export default Header;
